import { Button } from '@material-ui/core';
import { getColor } from 'common/constants/_colors';
import { STICKY_OFFSET } from 'components/base/common-styles';
import { StyledInput } from 'components/base/Input';
import { verticalScroller } from 'components/base/scroller';
import { StyledTableCell } from 'components/base/Table/Table.styles';
import styled from 'styled-components';

export const StyledEmptyStateDescription = styled.div`
  font-size: 1.2rem;
`;

export const StyledFilterSetsList = styled.div`
  padding: 2.5rem 2.5rem;
`;

export const StyledList = styled.div`
  width: 65rem;
  margin-bottom: 1rem;
  height: 20rem;
  ${verticalScroller()};
`;

export const StyledHeader = styled.div`
  margin-bottom: 2rem;
`;

export const StyledSetListFiltersSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  ${StyledInput} {
    width: 30rem;
  }
`;

export const StyledTitle = styled.div`
  margin-bottom: 2rem;
  font-size: 1.5rem;
`;

export const StyledButton = styled(Button)`
  width: 15rem;
  &.selected {
    background-color: ${getColor('titanWhite')} !important;
  }
  margin-right: 0.1rem;
  & svg {
    margin-right: 1rem;
    width: 1.3rem;
  }
`;

export const StyledFilterSetsTable = styled.div`
  .MuiTableCell-root {
    padding: 0;
    height: 3rem;
  }

  .MuiTableHead-root .MuiTableCell-head {
    border-bottom: 1px solid ${getColor('catskillGray')};
  }

  .MuiTableBody-root .MuiTableCell-body {
    border-bottom: 1px solid ${getColor('catskillGray')};
  }

  & ${StyledTableCell} {
    &.isSorted {
      box-shadow: none;
      background: transparent;
    }
  }
  margin-top: -${STICKY_OFFSET}rem;
`;

export const StyledProjectIcon = styled.div`
  display: flex;
  margin-right: 0.5rem;
`;
